import { Helmet } from "react-helmet-async"
import { WhatsAppAccountsDetails } from "../../../../../../Integrations"
import { useOutletContext } from "react-router"

export default function WhatsAppIntegrationAccountsPage() {
	const context = useOutletContext<{
		integrationId: string
		appId: number
	}>()

	return (
		<>
			<Helmet>
				<title>Accounts | WA</title>
			</Helmet>
			<WhatsAppAccountsDetails
				integratedAppId={context.appId}
				integrationId={context.integrationId}
			/>
		</>
	)
}
